import LOCAL_STORAGE_EVENT_KEY from './localStorage.event.key';

const createEvent = (key: string, newValue: string | null) =>
  new CustomEvent(LOCAL_STORAGE_EVENT_KEY, { detail: { key, newValue } });

const notify = (key: string, newValue: string | null) => {
  const storageEvent = createEvent(key, newValue);

  window.dispatchEvent(storageEvent);
};

export default notify;
